import React, { useState, useEffect } from "react";
import styles from './InstallButton.module.css';

function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("Resultado instalación:", outcome);

    setDeferredPrompt(null);
    setVisible(false);
  };

  const handleCerrar = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.installButtonContainer}>
        <button className={styles.closeButton} onClick={handleCerrar}>
          ×
        </button>
        <p className={styles.installButtonText}>¡Instala nuestra App Ciudadana para una mejor experiencia!</p>
        <button className={styles.installButton} onClick={handleInstall}>
          Instalar ahora
        </button>
      </div>
    </div>
  );
}

export default InstallButton;
